<template>
    <div>
        <div>
            <v-menu
                bottom
                right
                offset-y
                :internal-activator="true"
                v-model="openMenu"
                content-class="no-contain overflow-visible"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn style="padding: 0px 25px !important; margin-right: 10px;"
                         color="primary" dark v-on="on">
                    <span>Tìm kiếm</span>
                    <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-card
                    width="400px"
                    outlined
                    class="ma-0"
                >
                  <validation-observer v-slot="{ handleSubmit }">
                    <v-row class="px-5 py-5 mt-3">
                      <v-col cols="12" class="py-0">
                        <validation-provider
                            v-slot="{ errors }"
                            name="Call center">
                          <v-autocomplete
                              v-model="filterForm.contactSourceId"
                              :items="contactSourceList"
                              :error-messages="errors"
                              item-text="name"
                              item-value="id"
                              label="Nguồn"
                              color="primary"
                              multiple
                              eager
                              placeholder="Chọn nguồn"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <validation-provider
                            :rules="{}"
                            v-slot="{ errors }"
                            name="Nhóm sản phẩm">
                          <v-autocomplete
                              v-model="filterForm.productGroupId"
                              :items="productGroupList"
                              :error-messages="errors"
                              item-text="name"
                              item-value="id"
                              label="Nhóm sản phẩm"
                              color="primary"
                              multiple
                              clearable
                              placeholder="Chọn nhóm sản phẩm"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            :rules="{
                              regex: regex.isNumber
                            }"
                            name="Độ ưu tiên">
                          <v-text-field
                              @keydown.space.prevent
                              v-model="filterForm.priority"
                              label="Độ ưu tiên"
                              :error-messages="errors"
                              color="primary"
                              placeholder="Nhập số"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <div class="text-center mb-4">
                      <v-btn
                          class="primary mx-0"
                          @click.prevent="handleSubmit(search)"
                      >
                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                      </v-btn>
                    </div>
                  </validation-observer>
                </v-card>
            </v-menu>
        </div>
    </div>
</template>

<script>
import { regex } from '../../../helpers/constants'
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      default: () => ({}),
    },
    contactSourceList: {
      default: () => ([]),
    },
    productGroupList: {
      default: () => ([]),
    },
  },
  data () {
    return {
      openMenu: false,
      regex
    }
  },
  methods: {
    search () {
      this.openMenu = false
      Bus.$emit('priority-setting-list-filter', this.filterForm)
    },
  },
}
</script>

<style scoped>
.v-text-field {
  margin-top: 0 !important;
}
</style>
